import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';

Vue.use(DateRangePicker);
